import { STATUS_LABELS } from "@/lib/api";

// Design System v2 — pill con dot indicador y fondo tintado.
// Colores por estado (fondo + dot + texto).
const STATUS_TOKENS = {
  recibido:            { bg:"#E7EEFD", tx:"#1D4EBF", dot:"#2F6FED", br:"rgba(47,111,237,.18)" },
  en_diagnostico:      { bg:"#FFF7E6", tx:"#8C5A00", dot:"#D68A00", br:"rgba(214,138,0,.22)" },
  en_reparacion:       { bg:"#EFF3E6", tx:"#3F5222", dot:"#6E8B3D", br:"rgba(110,139,61,.22)" },
  listo_para_entregar: { bg:"#E6F6EE", tx:"#136A34", dot:"#22A05B", br:"rgba(34,160,91,.22)" },
  listo_sin_reparacion:{ bg:"#FFEDD9", tx:"#9A4A00", dot:"#E07A17", br:"rgba(224,122,23,.22)" },
  entregado:           { bg:"#F1EBFB", tx:"#4E2E86", dot:"#6D4AA6", br:"rgba(109,74,166,.22)" },
  cancelado:           { bg:"#FDEDE7", tx:"#8C2B14", dot:"#B4381F", br:"rgba(180,56,31,.22)" },
};

export function StatusPill({ status, className = "" }) {
  const t = STATUS_TOKENS[status] || { bg:"#EEF0EA", tx:"#4B5158", dot:"#8A9098", br:"rgba(0,0,0,.08)" };
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`ds-pill ${className}`}
      style={{
        background: t.bg,
        color: t.tx,
        borderColor: t.br,
      }}
    >
      <span className="dot" style={{ background: t.dot }} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

// Pill de Sección: tintada con el color del estado al que pertenece (sin dot).
export function SectionPill({ section, status, className = "" }) {
  if (!section) return <span className="text-[#525252]">—</span>;
  const t = STATUS_TOKENS[status] || { bg:"#EEF0EA", tx:"#4B5158", br:"rgba(0,0,0,.08)" };
  return (
    <span
      data-testid="section-pill"
      className={`ds-pill ${className}`}
      style={{ background: t.bg, color: t.tx, borderColor: t.br }}
    >
      {section}
    </span>
  );
}
